import { render, staticRenderFns } from "./InsightsView.vue?vue&type=template&id=f0070f3c&"
import script from "./InsightsView.vue?vue&type=script&lang=js&"
export * from "./InsightsView.vue?vue&type=script&lang=js&"
import style0 from "./InsightsView.vue?vue&type=style&index=0&id=f0070f3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports